import React from "react";
import { format } from "date-fns";
import { getSweepStaleness, SWEEP_LEVEL_STYLES } from "@/race-tracker/lib/sweepUtils";
import { ExternalLink } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/race-tracker/components/ui/tooltip";

export default function RaceRow({ race, onClick }) {
  const isDone = race.status === "Done";
  const isInactive = race.status === "Inactive";

  const digitalSweep = getSweepStaleness(race.last_digital_sweep);
  const digitalStyle = SWEEP_LEVEL_STYLES[digitalSweep.level];
  const linearSweep = getSweepStaleness(race.last_linear_sweep);
  const linearStyle = SWEEP_LEVEL_STYLES[linearSweep.level];

  return (
    <div
      className={`px-4 py-2 grid grid-cols-[1fr_1fr_1fr_1fr_1fr_1fr_80px_80px_120px_60px] gap-2 items-center cursor-pointer hover:bg-accent/50 transition-colors border-b border-border last:border-b-0 text-xs ${
        isDone ? "opacity-40" : isInactive ? "opacity-60" : ""
      }`}
      onClick={onClick}
    >
      <span className="font-medium">{race.state}</span>
      <span className="text-muted-foreground truncate">{race.chamber}</span>
      <span className="font-mono">{race.district || "—"}</span>
      <span className="text-muted-foreground truncate">{race.team || "—"}</span>
      <span className="text-muted-foreground">{race.election_type || "—"}</span>
      <span className="text-muted-foreground">
        {race.election_date ? format(new Date(race.election_date), "MMM d, yyyy") : "—"}
      </span>
      {/* Digital Sweep staleness */}
      <span className={`flex items-center gap-1 ${digitalStyle.text}`}>
        <span className={`w-2 h-2 rounded-full shrink-0 ${digitalStyle.dot}`} />
        {digitalSweep.days === null ? <span className="text-[10px]">—</span> : <span className="text-[10px]">{digitalSweep.days}d ago</span>}
      </span>
      {/* Linear Sweep staleness */}
      <span className={`flex items-center gap-1 ${linearStyle.text}`}>
        <span className={`w-2 h-2 rounded-full shrink-0 ${linearStyle.dot}`} />
        {linearSweep.days === null ? <span className="text-[10px]">—</span> : <span className="text-[10px]">{linearSweep.days}d ago</span>}
      </span>
      {race.markets ? (
        <TooltipProvider delayDuration={200}>
          <Tooltip>
            <TooltipTrigger asChild>
              <span className="text-muted-foreground truncate cursor-default underline decoration-dotted">{race.markets}</span>
            </TooltipTrigger>
            <TooltipContent side="top" className="max-w-xs text-xs bg-white text-black border border-border">
              {race.markets}
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      ) : (
        <span className="text-muted-foreground">—</span>
      )}
      <span className="text-right">
        {race.reference_link ? (
          <a
            href={race.reference_link}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex justify-end text-primary hover:text-primary/80 transition-colors"
            onClick={(e) => e.stopPropagation()}
          >
            <ExternalLink className="w-3.5 h-3.5" />
          </a>
        ) : (
          <span className="text-muted-foreground">—</span>
        )}
      </span>
    </div>
  );
}